import { useLocation } from "react-router-dom";
import { useState } from "react";
import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import MatchSideBar from "../Components/MatchSideBar";
import { useEffect } from "react";
import axiosInstance from "../Features/axios";

const ConfigContext = React.createContext();

const AppLayout = ({ children }) => {
  const location = useLocation();
  const hideHeaderRoutes = ["/verify-email", "/scoreboard", "/scoreboard2", "/scoreboard3", "/scoreboard4", "/scoreboard5", "/virtualCard", "/scoreboard6", "/scoreboard7", "/virtualGround", "/cardscoreboard"];
  const shouldHideHeader = hideHeaderRoutes.includes(location.pathname);
  const shouldHideMatchSidebar = location.pathname.startsWith("/news") || location.pathname.startsWith("/full-score");
  const [configData, setConfigData] = useState(null);

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const domain = process.env.REACT_APP_DOMAIN_URL;
        console.log("🚀 ~ getConfigData ~ domain:", domain)
        const response = await axiosInstance.post("/api/configData", {
          domain,
        });
        setConfigData(response.data?.result);
      } catch (error) {
        console.error("Failed to fetch whitelabel config:", error);
      }
    };

    getConfigData();
  }, []);

  return (
    <ConfigContext.Provider value={{ configData }}>
      {configData ? (
        <>
          {!shouldHideHeader && <Header />}

          {shouldHideHeader || shouldHideMatchSidebar ? (
            <>{children}</>
          ) : null}
          {/* ) : (
            <div id="main" className="main-container">
              <div className="container">
                <div className="row">
                  {children}
                  <MatchSideBar />
                </div>
              </div>
            </div>
          )} */}

          {!shouldHideHeader && <Footer />}
        </>
      ) : (
        <div className="loading-container">Loading configuration...</div>
      )}
    </ConfigContext.Provider>
  );
};

export { ConfigContext };
export default AppLayout;